/**
 * Features whose implementation lives in the copyrighted `enterprise/`
 * directory and therefore cannot be offered on a Community Edition
 * installation.
 *
 * Derived from every entry marked `premium: true` in config/features.yml.
 * Anything listed here is hidden from the dashboard entirely: no sidebar
 * entry, no settings page, no upsell, no paywall.
 *
 * NOTE: `help_center` appears in dashboard/featureFlags.js PREMIUM_FEATURES
 * but is NOT premium in config/features.yml, and it works fine on CE.
 * It is deliberately absent from this list.
 *
 * Re-check this list against config/features.yml after every upgrade:
 *   ruby -ryaml -e 'puts YAML.load_file("config/features.yml").select { |f| f["premium"] }.map { |f| f["name"] }'
 */
export const CE_HIDDEN_FEATURES = [
  'advanced_assignment',
  'advanced_search',
  'advanced_search_indexing',
  'audit_log_ip_address',
  'audit_logs',
  'captain_document_auto_sync',
  'captain_integration',
  'captain_integration_v2',
  'captain_v1_action_classifier',
  'channel_voice',
  'companies',
  'conversation_required_attributes',
  'csat_review_notes',
  'custom_roles',
  'custom_tools',
  'disable_branding',
  'help_center_embedding_search',
  'saml',
  'sla',
];

/**
 * Extra features to hide that are not premium, but that Kavanah does not
 * offer to mission teams. Add or remove freely; these are plain CE features.
 * Example: 'channel_tiktok', 'crm', 'linear_integration'
 */
export const LOCALLY_DISABLED_FEATURES = [];

export const HIDDEN_FEATURES = [
  ...CE_HIDDEN_FEATURES,
  ...LOCALLY_DISABLED_FEATURES,
];

export const isHiddenFeature = featureFlag =>
  Boolean(featureFlag) && HIDDEN_FEATURES.includes(featureFlag);
